/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto } from '../models/Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto';
import type { Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto } from '../models/Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto';
import type { Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto } from '../models/Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto';
import type { Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_MarketPriceResponseDto } from '../models/Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_MarketPriceResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FairMarketValueConfigurationService {

    /**
     * @returns Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationFairMarketValueConfiguration(): CancelablePromise<Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/fair-market-value-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFairMarketValueConfigurationUpdateFairMarketValueConfiguration(
requestBody?: Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_CreateUpdateFairMarketValueConfigurationServiceDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/fair-market-value-configuration/update-fair-market-value-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationFmvTypesForFmvConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/fmv-types-for-fmv-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationFmvTypesForFmvConfigurationExceptSales(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/fmv-types-for-fmv-configuration-except-sales',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationSettlementTypesForFmvConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/settlement-types-for-fmv-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationAwardTypesForFmvConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/award-types-for-fmv-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationTransactionTypesForFmvConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/transaction-types-for-fmv-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationTransasctionTypesForFmvConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/transasction-types-for-fmv-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardType 
     * @param grantDate 
     * @returns Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_MarketPriceResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairMarketValueConfigurationMarketPrice(
awardType?: string,
grantDate?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_FairMarketValueConfigurationService_MarketPriceResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-market-value-configuration/market-price',
            query: {
                'awardType': awardType,
                'grantDate': grantDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
